<template>
  <div>
   <div class="col-md-6 appinfopage">
      <h4 class="h4-title">{{pageTitle}}</h4>
      <form v-on:submit.prevent="saveAppData">
        <div class="form-group ">
          <label for="formGroupExampleInput">Name</label>
          <input
            type="text"
            class="form-control"
            id="name"
            placeholder="Required"
            v-model="AppForm.name"
            :disabled="pageMode===1"
            required
          >
        </div>
        <div class="form-group">
          <label for="formGroupExampleInput2">Remark</label>
          <input
            type="text"
            class="form-control"
            id="remark"
            placeholder="(Optional) No longer than 200 characters"
            v-model="AppForm.remark"
          >
        </div>
        <hr />
        <div>
          <div class="form-group row">
            <div class="col-sm-10">
              <button
                type="submit"
                class="btn btn-primary"
              >Save</button>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-lg-12">
               <b-alert show variant="success" v-if="saveDone">Successfully saved.</b-alert>
              <b-alert show variant="danger" v-if="isError">{{errorMessage}}</b-alert>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import AppForm from '@/models/msgappform.js';
export default {
  data () {
    return {
      appId: '',
      pageTitle: 'Create App',
      errorMessage: '',
      saveDone: false,
      isError: false,
      pageMode: 0, // 0 = Entry, 1 = Edit
      AppForm: {}
    };
  },
  watch: {
    '$route' (to, from) {
      if ('messaging-create-app' === to.name) {
        this.pageMode = 0;
        sessionStorage.removeItem('msgapp');
        this.setDefaults();
        this.AppForm = { name: '', remark: '' };
      }
    }
  },
  methods: {
    setDefaults () {
      this.appId = this.$route.params.id;

      if (this.appId) {
        this.pageTitle = 'Edit App';
        this.getApp();
        this.pageMode = 1;
      } else {
        this.pageTitle = 'Create App';
        this.pageMode = 0;
      }
    },
    getApp () {
      let msgapp = JSON.parse(sessionStorage.getItem('msgapp'));

      if (msgapp) {
        if (this.appId === msgapp.id) {
          this.AppForm = new AppForm(msgapp);
        }
      }
    },
    saveAppData () {
      const appForm = new AppForm(this.AppForm);
      const fd = new FormData();

      for (let key in appForm) {
        if (appForm[key]) {
          fd.append(key, appForm[key]);
        }
      }

      if (0 === this.pageMode) {
        // create
        this.axios({
          method: 'post',
          url: (`${process.env.VUE_APP_URL_MESSAGING_API}/app`),
          data: fd
        }).then(res => {
          const respData = res.data;
          if ('Success' === respData.message) {
            sessionStorage.removeItem('msgapp');
            this.saveDone = true;
            this.goToAppList();
          }
        })
          .catch(error => {
            this.isError = true;
            console.log('Error :', error.response);
            this.errorMessage = error.response.data.data[0].msg;
          });
      } else if (1 === this.pageMode) {
        // update
        this.axios({
          method: 'patch',
          url: (`${process.env.VUE_APP_URL_MESSAGING_API}/app/${this.appId}`),
          data: fd
        }).then(res => {
          const respData = res.data;
          if ('Success' === respData.message) {
            sessionStorage.removeItem('msgapp');
            this.saveDone = true;
            this.goToAppList();
          }
        })
          .catch(error => {
            this.isError = true;
            console.log('Error :', error.response);
            this.errorMessage = error.response.data.data[0].msg;
          });
      }
    },
    goToAppList (id) {
      this.$router.push({ name: 'messaging-app-list' });
    }
  },
  mounted () {
    this.setDefaults();
    document.title = 'Admin Console: Messaging App Form';
  }
};
</script>
